<div class="global-alerts-bar" *ngIf="!loading && areNotificationsDisabled">
  <p class="global-alerts-bar-alert" *ngIf="areNotificationsDisabled">
    <i class="material-symbols-outlined">warning</i> Email sending is disabled for this account. To enable emails and
    notifications, please speak to your system administrator
  </p>
</div>
